import { TLocation } from '../types/location';

export function locationHasNeighbors(location: TLocation): boolean {
  if (location === 'moscow_mo' || location === 'spb_lo') {
    return false;
  }

  return !!location.hasNeighbors;
}
